<template>
  <div class="p-product">
    <v-img :src="template.banner" :height="bannerHeight">
      <v-layout justify-center align-center fill-height class="light">
        <h1 class="font-weight-medium">{{template.title}}</h1>
      </v-layout>
    </v-img>
    <v-container class="p-product-list">
      <!-- <v-tabs
        v-model="tabActive"
        class="category-tabs"
        :class="{'hide-tabs_bar':categories.length < 2}"
      >
        <v-tab v-for="tab in categories" :key="tab.name" ripple>{{ tab.name }}</v-tab>
        <v-tab-item v-for="category in categories" :key="category.name">
          <ListItem v-for="item in category.products" :key="item.code" :code="item.code"></ListItem>
        </v-tab-item>
      </v-tabs>-->
      <div v-for="category in categories" :key="category.name">
        <ListItem v-for="item in category.products" :key="item.code" :code="item.code"></ListItem>
      </div>
    </v-container>
  </div>
</template>

<script>
import ListItem from "./components/ListItem";
export default {
  components: {
    ListItem
  },
  props: {
    type: {
      type: Number,
      default() {
        return 1;
      },
      validator(value) {
        // 目前只允许 1：团险 或 2：个险，暂不允许 0：所有
        return [1, 2].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      tabActive: 0,
      templates: [
        {
          title: "企业团体保障",
          banner: "/images/banner/group-banner-new.png",
          value: 1
        },
        {
          title: "员工个人保障",
          banner: "/images/banner/person-banner-new.png",
          value: 2
        }
      ]
    };
  },
  computed: {
    isGroup() {
      return this.type === 1;
    },
    template() {
      return this.templates.find(item => item.value === this.type);
    },
    categories() {
      const categories = this.$store.getters.getCategoryList(this.type, true);
      return categories;
    },
    bannerHeight() {
      return this.$vuetify.breakpoint.name === "xs" ? 150 : 377;
    }
  }
};
</script>

<style lang="scss">
.p-product {
  h1 {
    font-size: 2.5em;
  }
}
.p-product-list {
  // tabs 少于两个的时候隐藏
  .hide-tabs_bar {
    .v-tabs__bar {
      display: none;
    }
  }
  .category-tabs {
    .v-tabs__bar {
      // padding: 8px 20px;
      padding-left: 20px;
      .v-tabs__item {
        font-size: 14px;
        // color: $font-color;
        // opacity: 1;
      }
      // tabs 文字下的滑动线
      .v-tabs__slider {
        width: 32px;
        margin: auto;
      }
    }
  }
}
</style>


